import { useMutation } from '@tanstack/react-query';
import { z } from 'zod';
/**
 * Record that the member opened the Emotional Storm overlay.
 *
 * ── The narrowest row this API holds, and that is the licence ────────────
 * It stores a member id and a timestamp and nothing else: no emotion chip, no
 * note, no step reached, no duration. §5.2 of the spec is explicit that the SOS
 * surface records no incident and names no person, and this is the one row that
 * names one. It earns that by recording *that a self-help tool was used*, never
 * *that something happened to somebody*.
 *
 * Readable only by the member it belongs to — no admin surface, no export, no
 * aggregate — and it emits **no audit event**, the single deliberate exception
 * to this API's emit-on-every-write rule: the audit table is permanent and
 * staff-readable, so emitting would create exactly the per-parent record of
 * distress the model is shaped to avoid.
 *
 * ── Call it on OPEN, and do not derive it ────────────────────────────────
 * Never infer a storm from `GET /sos` — an editor previewing the overlay
 * fetches that too, which would make "storms weathered" a count of page loads.
 *
 * No idempotency key: two storms in one evening are two storms.
 *
 * Failure is swallowed by the caller. A parent reaching for this is in the one
 * moment the product must not interrupt with an error toast about telemetry.
 */
export function useRecordSosSession(http) {
    return useMutation({
        mutationFn: () => http.post('/sos/sessions', undefined, {
            schema: z.object({}).passthrough(),
        }),
    });
}
//# sourceMappingURL=sessions.js.map